import React from 'react'

import './index.css'

const PageTitle = props => {
  const { title, label, logo, className = '', withCross = false } = props
  return <div className={`page__title transition ${className}`}>
    {
      !withCross
        ? <div className='gray-line' />
        : <div className='flex-row'>
          <div className='gray-line gray-color-2' />
          <span className='gray-color-2'>+</span>
        </div>
    }

    {
      logo &&
      <img src={logo} className='title-logo transition' alt='page icon' />
    }
    <div className='page__title-container'>
      <h1 className='transition'>{title}</h1>
      <h3 className='transition'>{label}</h3>
    </div>
  </div>
}

export default PageTitle